
        /* from https://stackoverflow.com/a/74433390 */
        import { Buffer } from "buffer/"; // <-- no typo here ("/")
        import process from "process";
      
        window.Buffer = Buffer;
        window.process = process;
    